import script from "./TemplatePesanView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplatePesanView.vue?vue&type=script&setup=true&lang=ts"

import "./TemplatePesanView.vue?vue&type=style&index=0&id=32ac66bc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ac66bc"]])

export default __exports__